var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"like like_btn",class:{'active' : _vm.boardData.is_like === true},attrs:{"disabled":_vm.disabledBtn()},on:{"click":_vm.runLikeFunc}},[_c('span',[_vm._v(_vm._s(_vm.returnCount(_vm.boardData.wr_good, 999)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }